import {useMutation} from "@apollo/client";
import {SyncWorkflowUsersDocument} from "generated/graphql";

export const useSyncWorkflowUsers = () => useMutation(SyncWorkflowUsersDocument);